import { parseISO } from "date-fns";
import { IEmployeeAbsences } from "../../../domain/absences/IEmployeeAbsenceInfo";
import { ICalendar } from "../../../domain/calendars/ICalendar";
import { ICalendarEvent } from "../../../domain/calendars/ICalendarEvent";
import { IRoomEmployee } from "../../../domain/calendars/IRoom";

export const mapCalendarEvents = (x: any): ICalendarEvent => ({
    oid: x.oid,
    start: parseISO(x.start),
    end: parseISO(x.end),
    description: x.description,
    status: x.status,
    isEntireDay: x.isEntireDay,
    hideOtherEvents: x.hideOtherEvents
});

export const mapEmployeeAbsenceInfo = (x: any): ICalendar => ({
    id: x.id,
    name: x.name,
    calendarEvents: (x.calendarEvents || []).map(mapCalendarEvents),
    meetingEnd: x.meetingEnd,
    status: x.status,
    userType: x.userType
});

export const mapRoomEmployee = (x: any): IRoomEmployee => ({
    id: x.id,
    name: x.name,
    start: x.start,
    end: x.end
});

export const mapEmployeeAbsences = (x: any): IEmployeeAbsences => ({
    currentlyInMeeting: x.currentlyInMeeting,
    exchangeSyncedAt: x.exchangeSyncedAt,
    calendars: x.calendars.map(mapEmployeeAbsenceInfo)
});
